export default __webpack_public_path__ + "static/media/alheli_logo.8ed8ffda.jpg";